import styled from "styled-components";
import { Button, Form, FormInstance, Input, Modal } from "antd";
import { PatternFormat } from "react-number-format";
import InlineSvg from "react-inlinesvg";
import { useTranslation } from "react-i18next";

import { icons } from "@constants/icons";
import { colors } from "@constants/colors";
import { checkTemp } from "@utils/validate";
import configStore from "@zustand/configStore";
import { checkCondition } from "@utils/checkEmpty";

type Props = {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  form: FormInstance<any>;
};

const ModalFollower = ({ visible, onOk, onCancel, form }: Props) => {
  const { t } = useTranslation();
  const { config } = configStore();
  const configForm = config.configFormTransaction;

  return (
    <Contents id="modal-follower">
      <Modal
        maskClosable={false}
        title={`${t("Modal:header.follower_form")}`}
        open={visible}
        onOk={onOk}
        onCancel={onCancel}
        getContainer={() =>
          document.getElementById("modal-follower") as HTMLElement
        }
        footer={
          <>
            <Button type="text" onClick={onCancel}>
              <InlineSvg src={icons.arrow} /> {`${t("Home:btn.cancel")}`}
            </Button>
            <Button type="text" onClick={onOk} className="footer-save">
              {`${t("Modal:button.save_follower")}`}
              <InlineSvg src={icons.done} />
            </Button>
          </>
        }
      >
        <Form form={form} autoComplete="off" layout="vertical">
          <Form.Item
            label={`${t("Modal:form.step2.label.follower_name")}`}
            name={"name_follower_modal"}
            hidden={configForm?.name_follower?.display === false}
            rules={checkCondition(
              visible && configForm?.name_follower?.required,
              [
                {
                  required: configForm?.name_follower?.required ?? true,
                  message: `${t("Modal:form.step2.error.follower_name")}`,
                },
              ],
              [],
            )}
          >
            <Input
              placeholder={`${t("Modal:form.step2.placeholder.follower_name")}`}
            ></Input>
          </Form.Item>
          <Form.Item
            label={`${t("Modal:form.step2.label.follower_surname")}`}
            name={"surname_follower_modal"}
            hidden={configForm?.surname_follower?.display === false}
            rules={checkCondition(
              visible && configForm?.surname_follower?.required,
              [
                {
                  required: configForm?.surname_follower?.required ?? true,
                  message: `${t("Modal:form.step2.error.follower_surname")}`,
                },
              ],
              [],
            )}
          >
            <Input
              placeholder={`${t(
                "Modal:form.step2.placeholder.follower_surname",
              )}`}
            ></Input>
          </Form.Item>
          <Form.Item
            label={`${t("Modal:form.step2.label.temperature")}`}
            name={"temp_follower_modal"}
            hidden={configForm?.temp_follower?.display === false}
            rules={[
              {
                required: configForm?.temp_follower?.required ?? true,
                message: `${t("Sell-Transport:transport.error.temperature")}`,
              },
              {
                validator: (_, value) =>
                  checkCondition(value, checkTemp(_, value), Promise.resolve()),
              },
            ]}
          >
            <PatternFormat
              placeholder={`${t("Modal:form.step2.placeholder.temperature")}`}
              customInput={Input}
              format={"##.#"}
            ></PatternFormat>
          </Form.Item>
        </Form>
      </Modal>
    </Contents>
  );
};

export default ModalFollower;

const Contents = styled.div`
  .ant-modal-content {
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 50%);
    border-radius: 0.3rem;
    padding: 0px;
    .ant-form-item-explain-error {
      text-align: start;
    }
  }
  .ant-modal-close {
    color: white;
  }
  .ant-modal-header {
    background: ${colors.basegreen};
    text-align: start;
    border-radius: 0.3rem 0.3rem 0 0;
    padding: 20px 24px;
    .ant-modal-title {
      color: #fff;
    }
  }
  .ant-modal-footer {
    background: ${colors.basegreen};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 0.3rem 0.3rem;
    padding: 18px 24px;
    .ant-btn-text {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      :hover {
        opacity: 1;
      }
    }
    .footer-save {
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      color: ${colors.green721};
      width: 33%;
      @media (max-width: 600px) {
        width: 50%;
      }
    }
  }
  .ant-modal .ant-modal-body {
    padding: 0px 20px;
    margin-top: 20px;
  }
`;
